import React from 'react';
import { Outlet } from 'react-router-dom';

const PaperHome = () => (
  <section className="app-route">
    <Outlet />
  </section>
);

export default PaperHome;